import React from 'react';

import {
  HEATING_OIL,
  LANDSCAPING,
  NATURAL_GAS,
  SEPARATE_HEATING_CHARGE,
  SNOW_REMOVAL,
} from '../../../../shared/constants/index';
import type { Section } from '../../../../shared/models/index';
import type { SwitchObject } from '../../../../shared/models/Types';
import SwitchesWithTitle from '../../Widgets/SwitchesWithTitle';
import { isMultiFamily } from './Utilities/MultiFamilyLandlordUtility';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Services_v2({ section, setSectionValues }: Props): JSX.Element {
  function onLandscapingToggle(): void {
    toggleSwitch(LANDSCAPING.FIELD_NAME.IS_ENABLED);
  }

  function onSnowRemovalToggle(): void {
    toggleSwitch(SNOW_REMOVAL.FIELD_NAME.IS_ENABLED);
  }

  function onHeatingOilToggle(): void {
    toggleSwitch(HEATING_OIL.FIELD_NAME.IS_ENABLED);
  }

  function onNaturalGasToggle(): void {
    toggleSwitch(NATURAL_GAS.FIELD_NAME.IS_ENABLED);
  }

  function onSeparateHeatingChargeToggle(): void {
    toggleSwitch(SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED);
  }

  function toggleSwitch(key: string): void {
    setSectionValues({
      [key]: !section.getFieldValue(key),
    });
  }

  const multiFamilyServices: Array<SwitchObject> = [
    {
      text: 'Natural gas',
      onClick: onNaturalGasToggle,
      toggled: section.getFieldValue(NATURAL_GAS.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(NATURAL_GAS.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Heating oil',
      onClick: onHeatingOilToggle,
      toggled: section.getFieldValue(HEATING_OIL.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(HEATING_OIL.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Heating charge',
      onClick: onSeparateHeatingChargeToggle,
      toggled: section.getFieldValue(SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Landscaping',
      onClick: onLandscapingToggle,
      toggled: section.getFieldValue(LANDSCAPING.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(LANDSCAPING.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Snow removal',
      onClick: onSnowRemovalToggle,
      toggled: section.getFieldValue(SNOW_REMOVAL.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(SNOW_REMOVAL.FIELD_NAME.IS_ENABLED),
    },
  ];

  const singleFamilyServices: Array<SwitchObject> = [
    {
      text: 'Natural gas',
      onClick: onNaturalGasToggle,
      toggled: section.getFieldValue(NATURAL_GAS.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(NATURAL_GAS.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Heating oil',
      onClick: onHeatingOilToggle,
      toggled: section.getFieldValue(HEATING_OIL.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(HEATING_OIL.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Landscaping',
      onClick: onLandscapingToggle,
      toggled: section.getFieldValue(LANDSCAPING.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(LANDSCAPING.FIELD_NAME.IS_ENABLED),
    },
    {
      text: 'Snow removal',
      onClick: onSnowRemovalToggle,
      toggled: section.getFieldValue(SNOW_REMOVAL.FIELD_NAME.IS_ENABLED),
      disabled: section.isFieldDisabled(SNOW_REMOVAL.FIELD_NAME.IS_ENABLED),
    },
  ];

  return (
    <SwitchesWithTitle
      switches={isMultiFamily(section) ? multiFamilyServices : singleFamilyServices}
      title="Utilities and services"
      legend="Which of these additional utilities and services apply to the property?"
      description="You’ll be able to indicate who will be financially responsible in the next step."
    />
  );
}

export default Services_v2;
